import React, { useState } from "react";
import { motion } from "framer-motion";
import { Phone, Mail, MapPin, Check } from "lucide-react";
import api, { formatApiError } from "../api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      await api.post("/contact", form);
      setSent(true);
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail));
    }
  };

  const input = "w-full bg-neutral-50 border border-neutral-200 rounded-xl px-4 py-3 text-neutral-900 placeholder-neutral-400 focus:outline-none focus:border-brand-500 transition-colors";

  return (
    <main className="bg-ink min-h-screen pt-32 pb-16">
      <div className="max-w-6xl mx-auto px-6">
        <p className="text-brand-500 font-medium mb-2">Get in touch</p>
        <h1 className="font-display text-4xl md:text-5xl font-bold text-navy" data-testid="contact-heading">Contact my Property Pune</h1>
        <p className="text-neutral-500 mt-3 max-w-2xl">Have a construction project or property enquiry? Send us a message.</p>

        <div className="grid lg:grid-cols-3 gap-8 mt-12">
          <div className="space-y-4">
            {[
              { icon: MapPin, label: "Address", value: "Goodwill Crescent, Flat No. A-801, Keshavnagar, Mundhwa, Pune-36" },
              { icon: Phone, label: "Phone", value: "+91 9767617770 / +91 7038797966" },
              { icon: Mail, label: "Email", value: "naynesh14@gmail.com" },
            ].map((c) => (
              <div key={c.label} className="bg-surface border border-neutral-200 rounded-2xl p-5 shadow-card flex gap-3">
                <c.icon className="w-6 h-6 text-brand-500 shrink-0" />
                <div>
                  <p className="text-sm text-neutral-400">{c.label}</p>
                  <p className="text-neutral-800 font-medium">{c.value}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="lg:col-span-2 bg-surface border border-neutral-200 rounded-2xl p-6 md:p-8 shadow-card">
            {sent ? (
              <div className="text-center py-16" data-testid="contact-success">
                <Check className="w-12 h-12 text-brand-500 mx-auto mb-3" />
                <h3 className="text-xl font-bold text-neutral-900">Message sent!</h3>
                <p className="text-neutral-500 mt-1">Thank you — we'll be in touch shortly.</p>
              </div>
            ) : (
              <motion.form initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} onSubmit={submit} className="space-y-4" data-testid="contact-form">
                <div className="grid sm:grid-cols-2 gap-4">
                  <input required placeholder="Your name" className={input} value={form.name} onChange={set("name")} data-testid="contact-name" />
                  <input required type="email" placeholder="Email" className={input} value={form.email} onChange={set("email")} data-testid="contact-email" />
                </div>
                <div className="grid sm:grid-cols-2 gap-4">
                  <input placeholder="Phone" className={input} value={form.phone} onChange={set("phone")} data-testid="contact-phone" />
                  <input placeholder="Subject" className={input} value={form.subject} onChange={set("subject")} data-testid="contact-subject" />
                </div>
                <textarea required rows={5} placeholder="Your message" className={input} value={form.message} onChange={set("message")} data-testid="contact-message" />
                {err && <p className="text-red-500 text-sm">{err}</p>}
                <button type="submit" data-testid="contact-submit-btn"
                  className="px-6 py-3 font-semibold text-white bg-gradient-to-r from-brand-500 to-brand-600 rounded-xl hover:shadow-soft transition-all active:scale-95">
                  Send Message
                </button>
              </motion.form>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
